import React, { memo } from 'react';

import { log } from '../../services/utils';

import { useAuthState } from '../../contexts/AuthContext';

import NavItem from '../Shared/NavItem';
import PermissionsWrapper from '../PermissionsWrapper';

import styles from './sidebar.module.css';

const AdministrationSidebar = () => {
	const { user: { permissions } } = useAuthState();

	return (
		<div className={ styles.sidebarMenuContainer }>
			{ log( 'administrationSidebar' ) }
			<PermissionsWrapper permission={ permissions.listUsers.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="users"
					title="Users"
					to="/administration/users"
				/>
			</PermissionsWrapper>
			<PermissionsWrapper permission={ permissions.listTags.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="tags"
					title="Tags"
					to="/administration/tags"
				/>
			</PermissionsWrapper>
		</div>
	);
};

export default memo( AdministrationSidebar );
